module.exports = __webpack_public_path__ + "img/vehicle-slides-with-backdrop-chevy.1cf45d0b.png";